import {NS} from '../namespaces.js';
import accountDeletion from './accountDeletion.js';
import accountDeletionConfirm from './accountDeletionConfirm.js';
import accounts from './accounts.js';
import activityLog from './activityLog.js';
import balanceHistory from './balanceHistory.js';
import balanceRollout from './balanceRollout.js';
import billingHistory from './billingHistory.js';
import budgetManager from './budgetManager.js';
import categoryManager from './categoryManager.js';
import closingHistory from './closingHistory.js';
import common from './common.js';
import dashboard from './dashboard.js';
import deadlines from './deadlines.js';
import debtManager from './debtManager.js';
import debtPayoffPlan from './debtPayoffPlan.js';
import expenseGroup from './expenseGroup.js';
import expensesList from './expensesList.js';
import featureHighlights from './featureHighlights.js';
import financeAnalysis from './financeAnalysis.js';
import forecastRollout from './forecastRollout.js';
import forecastAiHelper from './forecastAiHelper.js';
import forecastAiHistory from './forecastAiHistory.js';
import forecastPage from './forecastPage.js';
import forecastSummaryPage from './forecastSummaryPage.js';
import forecastSummaryCalendar from './forecastSummaryCalendar.js';
import forgotPassword from './forgotPassword.js';
import goalManager from './goalManager.js';
import growthProgram from './growthProgram.js';
import gptAnalysis from './gptAnalysis.js';
import home from './home.js';
import incomeList from './incomeList.js';
import invite from './invite.js';
import legal from './legal.js';
import liabilityManager from './liabilityManager.js';
import login from './login.js';
import menu from './menu.js';
import myInsights from './myInsights.js';
import notifications from './notifications.js';
import obligationsHub from './obligationsHub.js';
import passkeys from './passkeys.js';
import personalCircle from './personalCircle.js';
import publicInsights from './publicInsights.js';
import realTransactions from './realTransactions.js';
import recurrentExpenseManager from './recurrentExpenseManager.js';
import recurrentHub from './recurrentHub.js';
import recurrentIncomeManager from './recurrentIncomeManager.js';
import register from './register.js';
import repaymentPlans from './repaymentPlans.js';
import resetPassword from './resetPassword.js';
import rewardManager from './rewardManager.js';
import setup from './setup.js';
import status from './status.js';
import subscription from './subscription.js';
import supportHelp from './supportHelp.js';
import taskEvents from './taskEvents.js';
import tasksToConfirm from './tasksToConfirm.js';
import tempoMint from './tempoMint.js';
import timezones from './timezones.js';
import transactionsHub from './transactionsHub.js';
import skillsFactory from './skillsFactory.js';
import verifyEmail from './verifyEmail.js';

const mergeResources = (...modules) =>
  modules.reduce((acc, module) => {
    Object.entries(module).forEach(([lng, namespaces]) => {
      acc[lng] = acc[lng] || {};
      acc[lng] = {...acc[lng], ...namespaces};
    });
    return acc;
  }, {});

const buildUnifiedNamespace = (resources) => {
  const unified = {};

  Object.entries(resources).forEach(([ns, values]) => {
    if (values && typeof values === 'object') {
      unified[ns] = values;
      if (ns === NS.COMMON) {
        Object.assign(unified, values);
      }
    }
  });

  return unified;
};

export const getBaseResources = () => {
  const merged = mergeResources(accountDeletion, accountDeletionConfirm, accounts, activityLog, balanceHistory, balanceRollout, billingHistory, budgetManager, categoryManager, closingHistory, common, dashboard, deadlines, debtManager, debtPayoffPlan, expenseGroup, expensesList, featureHighlights, financeAnalysis, forecastRollout, forecastAiHelper, forecastAiHistory, forecastPage, forecastSummaryPage, forecastSummaryCalendar, forgotPassword, goalManager, growthProgram, gptAnalysis, home, incomeList, invite, legal, liabilityManager, login, menu, myInsights, notifications, obligationsHub, passkeys, personalCircle, publicInsights, realTransactions, recurrentExpenseManager, recurrentHub, recurrentIncomeManager, register, repaymentPlans, resetPassword, rewardManager, setup, skillsFactory, status, subscription, supportHelp, taskEvents, tasksToConfirm, tempoMint, timezones, transactionsHub, verifyEmail);

  return Object.entries(merged).reduce((acc, [lng, namespaces]) => {
    acc[lng] = {
      ...namespaces,
      [NS.ALL]: buildUnifiedNamespace(namespaces),
    };

    return acc;
  }, {});
};

export default getBaseResources;
